import { render } from "./LeftMenu.vue?vue&type=template&id=21001f4c&scoped=true&ts=true"
import script from "./LeftMenu.vue?vue&type=script&lang=ts"
export * from "./LeftMenu.vue?vue&type=script&lang=ts"

import "./LeftMenu.vue?vue&type=style&index=0&id=21001f4c&scoped=true&lang=css"

import exportComponent from "/opt/buildhome/repo/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-21001f4c"]])

export default __exports__